import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { CustomProductCardEnt } from 'src/app/shared/interfaces/custom-product-card-ent';
import { WishList } from 'src/app/utils/functions/wishList';

@Component({
  selector: 'app-delete-item-wish-list-modal',
  templateUrl: './delete-item-wish-list-modal.component.html'
})
export class DeleteItemWishListModalComponent implements OnChanges, OnInit {
  
  @Input() visible: boolean = false;
  @Input() product: CustomProductCardEnt = new CustomProductCardEnt();
  @Output() noVisible = new EventEmitter<boolean>();
  @Output() deleted = new EventEmitter<boolean>();

  item: IItemWishList = new IItemWishList();
  numItem: number = 0;
  totPriceWishList: number = 0;

  constructor(
    private wishList: WishList,
  ) {}

  ngOnInit(): void {
    this.item = this.wishList.getItemWishList(this.product);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.item = this.wishList.getItemWishList(this.product);
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
  }
  
  
  showDialog() {
    this.visible = true;
  }

  onDialogClose(){
    this.visible = false;
    this.noVisible.emit(this.visible);
  }

  cancelar(){
    this.visible = false;
    this.noVisible.emit(this.visible);
  }

  borrar(){
    this.visible = false;
    this.deleted.emit(this.visible);
  }

}